import { useNavigate } from "react-router-dom";
import CustomerList from "../../features/manageCustomers/customerList";
import CustomerTopbar from "../../features/manageCustomers/topbar";
import IfCan from "../../components/IfCan";
import { useState } from "react";

const ManageCustomers = () => {
  const [value, setValue] = useState("");

  const navigate = useNavigate();

  return (
    <>
      <IfCan module="Manage Customers" action="view">
        <div className="main_title">
          <h1>User Management</h1>
          <p>
            <span onClick={() => navigate("/dashboard")}>Dashboard</span> - User
            Management
          </p>
        </div>

        <div className="cards">
          <CustomerTopbar setValue={setValue} />
          <CustomerList searchTerm={value} />
        </div>
      </IfCan>
    </>
  );
};

export default ManageCustomers;
